
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { Playground } from 'docz';
import State from '../../../../docs/State';
import LabeledTextInput from '@devsisters/ui-careers/lib/LabeledTextInput';

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>

<MDXTag name="h1" components={components} props={{"id":"labeledtextinput"}}>{`LabeledTextInput`}</MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-tsx"}}>{`import { LabeledTextInput } from '@devsisters/ui/careers';
// 또는 import LabeledTextInput from '@devsisters/ui-careers/lib/LabeledTextInput';
`}</MDXTag></MDXTag>
<MDXTag name="h3" components={components} props={{"id":"놀이터"}}>{`놀이터`}</MDXTag>
<Playground __position={0} __code={'<State initialState={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <LabeledTextInput\n      style={{ fontSize: \'16px\', marginBottom: \'0.5em\' }}\n      labelStyle={{ width: \'100px\' }}\n      inputStyle={{ width: \'300px\' }}\n      label=\"항목\"\n      value={state.value}\n      onChange={value => setState({ value })}\n    />\n  )}\n</State>\n<State initialState={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <LabeledTextInput\n      style={{ fontSize: \'16px\', marginBottom: \'0.5em\' }}\n      labelStyle={{ width: \'100px\' }}\n      inputStyle={{ width: \'300px\' }}\n      label=\"필수항목\"\n      value={state.value}\n      onChange={value => setState({ value })}\n      placeholder=\"내용을 입력해주세요\"\n      required\n      error={!state.value && \'필수항목입니다.\'}\n    />\n  )}\n</State>'} __scope={{props: this ? this.props : props,State,LabeledTextInput}}>
  <State initialState={{ value: '' }}>
    {({ state, setState }) => (
      <LabeledTextInput
        style={{ fontSize: '16px', marginBottom: '0.5em' }}
        labelStyle={{ width: '100px' }}
        inputStyle={{ width: '300px' }}
        label='항목'
        value={state.value}
        onChange={value => setState({ value })}
      />
    )}
  </State>
  <State initialState={{ value: '' }}>
    {({ state, setState }) => (
      <LabeledTextInput
        style={{ fontSize: '16px', marginBottom: '0.5em' }}
        labelStyle={{ width: '100px' }}
        inputStyle={{ width: '300px' }}
        label='필수항목'
        value={state.value}
        onChange={value => setState({ value })}
        placeholder='내용을 입력해주세요'
        required
        error={!state.value && '필수항목입니다.'}
      />
    )}
  </State>
</Playground>
           </MDXTag>
  }
}
  